import { render, staticRenderFns } from "./CogneetivAI.vue?vue&type=template&id=85fb56d6&"
import script from "./CogneetivAI.vue?vue&type=script&lang=js&"
export * from "./CogneetivAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports